import { Tag, TagVariant } from '@deliveryhero/pd-cookbook/components/Tag';

import { SubscriptionStates } from 'services/api';
import { Column } from 'src/components/TableList/SortableHeader';

import { SubscribedListingData, UnsubscribedListingData } from '../types';

export const SubscribedColumns: Column<SubscribedListingData>[] = [
  {
    id: 'name',
    label: 'Name',
    format: (employee) => (
      <>
        <div>{employee.name}</div>
        <span
          style={{
            fontSize: '14px',
            lineHeight: '21px',
            color: '#767676'
          }}
        >
          {employee.email}
        </span>
      </>
    )
  },
  {
    id: 'subscription_start_date',
    label: 'Start Date'
  },
  {
    id: 'subscription_end_date',
    label: 'Renewal Date'
  },
  {
    id: 'subscription_plan',
    label: 'Plan'
  },
  {
    id: 'subscription_state',
    label: 'Status',
    format: (employee) => {
      if (employee.subscription_state === SubscriptionStates.enabled) {
        return <Tag id="enabled" label="Active" variant={TagVariant.SUCCESS} />;
      } else if (employee.subscription_state === SubscriptionStates.cancelled) {
        return (
          <Tag
            id="cancelled"
            label="Requested to Cancel"
            variant={TagVariant.POPULAR}
          />
        );
      } else if (
        employee.subscription_state ===
        SubscriptionStates.subscription_requested
      ) {
        return (
          <Tag
            id="subscription_requested"
            label="Requested"
            variant={TagVariant.POPULAR}
          />
        );
      }
    }
  }
];

export const UnsubscribedColumns: Column<UnsubscribedListingData>[] = [
  {
    id: 'name',
    label: 'Name',
    format: (employee) => (
      <>
        <div>{employee.name}</div>
        <span
          style={{
            fontSize: '14px',
            lineHeight: '21px',
            color: '#767676'
          }}
        >
          {employee.email}
        </span>
      </>
    )
  },
  {
    id: 'department_name',
    label: 'Department'
  }
];
